$(document).ready(function () {

    //size picker tooltips
    const sizeTooltipContainers = document.querySelectorAll('.tooltip-container');

    sizeTooltipContainers.forEach(container => {

        const tooltipTrigger = container.querySelector('.tooltip-trigger');
        const tooltipContent = container.querySelector('.tooltip-content');
        const tooltipClose = container.querySelector('.tooltip-close');

        tooltipClose.addEventListener('click', function(event) {
            event.preventDefault();
            tooltipContent.classList.remove('is--visible');
            tooltipClose.disabled = true;
        });

        tooltipTrigger.addEventListener('click', function(event) {
            event.preventDefault();
            tooltipContent.classList.toggle('is--visible');
            tooltipClose.disabled = !tooltipContent.classList.contains('is--visible');
        });
    });

    // filter tooltips
    const filterTooltipContainers = document.querySelectorAll('.filter-tooltip-container');

    filterTooltipContainers.forEach(container => {
        const tooltipTrigger = container.querySelector('.legend-tooltip');
        const tooltipContent = container.querySelector('.legend-tooltip-content');
        const tooltipLink = container.querySelector('.legend-tooltip-link');

        tooltipLink.addEventListener('click', function() {
            tooltipContent.classList.remove('is--visible');
            tooltipLink.disabled = true;
        });

        tooltipTrigger.addEventListener('click', function(event) {
            event.preventDefault();
            tooltipContent.classList.toggle('is--visible');
            tooltipLink.disabled = !tooltipContent.classList.contains('is--visible');
        });
    });
});